import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import CardDefault from "../../../../components/ui/cards/card-default/card-default";
import IconDescription from "../../../../components/ui/icon-description/icon-description";
import "./poles-installation.scss";

const PolesInstallation = () => {
  return (
    <section className="poles-installation">
      <Fade direction="up" duration={800} triggerOnce>
        <IntroSectionBadge
          badgeText={"COME FUNZIONANO"}
          title={"Processo di Installazione"}
          text={"Sistema innovativo in 3 fasi per fondazioni di eccellenza"}
          icon={"cube"}
          bgColor="dark"
        />
      </Fade>
      <Fade
        cascade
        direction="up"
        delay={200}
        duration={1000}
        damping={0.25}
        triggerOnce
      >
        <div className="poles-installation__cards-list">
          <CardDefault type={"light"} cardNumber={1}>
            <IconDescription
              icon={"eye"}
              title={"Penetrazione Controllata"}
              text={
                "La punta in acciaio penetra nel terreno tramite rotazione fino allo strato resistente, identificato tramite indagine geotecnica precedente."
              }
              type={"primary"}
              size={"medium"}
              direction="vertical-left"
            />
          </CardDefault>
          <CardDefault type={"light"} cardNumber={2}>
            <IconDescription
              icon={"truck-droplet"}
              title={"Getto del Cemento"}
              text={
                "Viene gettato il cemento armato all'interno del tubo forma, senza rimuovere terra dal terreno circostante."
              }
              type={"secondary"}
              size={"medium"}
              direction="vertical-left"
            />
          </CardDefault>
          <CardDefault type={"light"} cardNumber={3}>
            <IconDescription
              icon={"droplet-slash"}
              title={"Sistema a Secco"}
              text={
                "Il sistema funziona completamente a secco, senza necessità di acqua o fanghi bentonitici, riducendo costi e complessità."
              }
              type={"secondary"}
              size={"medium"}
              direction="vertical-left"
            />
          </CardDefault>
        </div>
      </Fade>
    </section>
  );
};

export default PolesInstallation;
